import React from 'react';
import { CellWrapper } from '../../styles';
import { ColumnProps } from '../../types';

export const CellFormatted = ({ value }: ColumnProps) => (
  <CellWrapper value={value}>
    {value}
  </CellWrapper>
);
